/**
 * Render a pop-up menu, different for mobile and desktop.
 */

import { memo, useCallback } from "react";
import { className } from "@/common/utils/strings";
import { IMenuItem, IMenuGroup } from "./types";

import "./PopupMenu.scss";

interface PopupMenuProps {
  groups: IMenuGroup[];
  onClick: (item: IMenuItem) => void;
  onClose: () => void;
  className?: string;
}

export const PopupMenu = memo((props: PopupMenuProps) => {
  const handleItemClick = useCallback((item: IMenuItem) => () => {
    props.onClick(item);
  }, [props.onClick]);

  const handleClose = useCallback(() => {
    props.onClose();
  }, [props.onClose]);

  return (
    <div className={className({
      "popupMenu": true,
      [props.className ?? ""]: true,
    })}>
      <div className="backdrop" onClick={handleClose}></div>

      <div className="canvas">
        <div className="grip"></div>

        {props.groups.map((group: IMenuGroup, gidx: number) => (
          <div key={gidx} className={className({
            "group": true,
            [group.className ?? ""]: true,
          })}>
            {group.text && (
              <div className="groupName">{group.text}</div>
            )}

            <div className="items">
              {group.items.map((item: IMenuItem, iidx: number) => (
                <div className={className({
                  "item": true,
                  [item.className ?? ""]: true,
                })} key={iidx} onClick={handleItemClick(item)}>
                  {item.icon}
                  <span className="label">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className="items">
        </div>
      </div>
    </div>
  );
});
